// Modules
import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import Textarea from 'react-textarea-autosize';
import trim from 'lodash/trim';

// Components
import TextWithNewlinesLinks from 'components/widgets/text/text-with-newlines-links';

export default class TaskNotes extends React.Component {
  static propTypes = {
    updateTask: PropTypes.func.isRequired,
    task: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);

    const taskNotes = props.task && props.task.notes;
    this.state = { editingNotes: !taskNotes, notes: taskNotes || '' };

    this.updateNotes = this.updateNotes.bind(this);
    this.startEditingNotes = this.startEditingNotes.bind(this);
    this.stopEditingNotes = this.stopEditingNotes.bind(this);
    this.onNotesBlur = this.onNotesBlur.bind(this);
  }

  componentWillUpdate(nextProps) {
    if (!nextProps.task.notes && !this.state.editingNotes) this.startEditingNotes();
  }

  componentDidUpdate(prevProps, prevState) {
    const isEditing = this.state.editingNotes;
    const wasEditing = prevState.editingNotes;

    if (isEditing && !wasEditing) ReactDOM.findDOMNode(this.input).focus();
  }

  onNotesBlur() {
    this.stopEditingNotes();
    this.setState({ notes: trim(this.state.notes) });
    this.props.updateTask({ notes: trim(this.state.notes) });
  }

  updateNotes(event) {
    this.setState({ notes: event.target.value });
  }

  startEditingNotes() {
    this.setState({ editingNotes: true });
  }

  stopEditingNotes() {
    if (this.props.task.notes) this.setState({ editingNotes: false });
  }

  render() {
    const { editingNotes, notes } = this.state;

    return (
      <div className="task-notes-wrapper">
        { !editingNotes &&
          <div onClick={this.startEditingNotes} className="task-notes">
            <TextWithNewlinesLinks text={notes} />
          </div>
        }

        { editingNotes &&
          <Textarea
            ref={input => { this.input = input; }}
            placeholder="Add notes to this task"
            className="unstyled-textarea"
            value={notes || ''}
            onChange={this.updateNotes}
            onBlur={this.onNotesBlur}
          />
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/models/ticket/task-notes.js